import script from "./UserForm.vue?vue&type=script&setup=true&lang=js"
export * from "./UserForm.vue?vue&type=script&setup=true&lang=js"

export default script